<template>
  <!-- 自适应-px写法-会导致和跳转过去的长得不一样 -->
  <header class="app-header" style="background-color: #145786; height: 63px">
    <div class="app-header__logo">
      <a href="/" style="display: flex">
        <img
          src="../../assets/iamges/logo1.jpg"
          class="logo"
          alt=""
          style="height: 37px; width: 117px"
        />

        <div class="splitLines"></div>
        <h3 class="app-title" style="font-size: 24px; left: 133px">
          国际贸易研究及决策支持系统
        </h3>
      </a>
      <el-dropdown class="dropClass" placement="top-start">
        <span class="el-dropdown-link">
          全部数据库分类<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="dropdownTopMenu">
          <div class="dropDiv">
            <div class="legend">
              <div style="margin-right: 10px">
                <span
                  style="
                    font-size: 22px;
                    color: #02a7f0;
                    margin-right: 2px;
                    margin-top: -9px;
                  "
                  >■</span
                >2026年新建
              </div>
              <div style="margin-right: 10px">
                <span
                  style="
                    font-size: 22px;
                    color: #d9001b;
                    margin-right: 2px;
                    margin-top: -9px;
                  "
                  >■</span
                >2025年新建
              </div>
              <div>
                <span
                  style="
                    font-size: 22px;
                    color: #70b603;
                    margin-right: 2px;
                    margin-top: -9px;
                  "
                  >■</span
                >2024年新建
              </div>
            </div>
            <div
              v-for="(item, index) in topMenuList"
              :key="index"
              class="databaseAll"
              :style="item.clearRow ? 'clear: both' : ''"
            >
              <el-col
                :span="
                  item.lists.length == 3
                    ? 12
                    : item.lists.length == 6
                    ? 24
                    : item.lists.length == 4
                    ? 16
                    : item.lists.length == 1
                    ? 4
                    : 8
                "
              >
                <div
                  class="databaseAllTitle"
                  :style="{
                    color: item.tilteColor ? item.tilteColor : '#004677',
                  }"
                >
                  {{ item.title }}
                </div>
                <div
                  class="databaseAllList"
                  :style="{
                    minWidth:
                      item.lists.length == 3
                        ? '33.33333%'
                        : item.lists.length == 6
                        ? '16.66%'
                        : item.lists.length == 4
                        ? '25%'
                        : item.lists.length == 1
                        ? '100%'
                        : '50%',
                  }"
                  v-for="(items, index) in item.lists"
                  :key="index"
                  @click="toLinks(items.links)"
                >
                  {{ items.title }}
                </div></el-col
              >
            </div>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </header>
  <!-- <header class="app-header" style="background-color: #004778">
    <div class="app-header__logo">
      <a href="/">
        <img src="../../assets/iamges/logo1.jpg" class="logo" alt="" />
      </a>
      <h3 class="app-title">国际贸易研究及决策支持系统数据平台</h3>
      <el-dropdown class="dropClass" placement="top-start">
        <span class="el-dropdown-link">
          下拉菜单<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="dropDiv">
            11111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </header> -->
</template>

<script>
import { mapGetters } from "vuex";
import { LOGIN_URL } from "../../utils/lang";
import { removeToken } from "../../utils/auth";

export default {
  name: "AppHeaderHome",
  data() {
    return {
      showShuoming: false,
      showHelp: false,
      type: "1",
      detail: {},
      url: LOGIN_URL(),
      topMenuList: [
        {
          title: "联合国统计署  >",
          tilteColor: "#e14a1b",
          lists: [
            {
              title: "世界货物贸易月度",
              links: "/data/goods/world/monthly",
            },
            {
              title: "世界货物贸易年度",
              links: "/data/goods/world/annual",
            },
            {
              title: "世界服务贸易年度",
              links: "/data/service-trade/world/annual",
            },
          ],
        },
        {
          title: "中国海关总署  >",
          tilteColor: "#e14a1b",
          lists: [
            {
              title: "中国货物贸易月度",
              links: "/data/goods/asia/china/monthly",
            },
            {
              title: "中国对外货物贸易指数",
              links: "/data/trade-index/china/monthly",
            },
            {
              title: "",
              links: "",
            },
          ],
        },
        {
          title: "东盟统计局  >",
          tilteColor: "",
          lists: [
            {
              title: "东盟货物贸易季度",
              links: "/data/goods/asean/monthly",
            },
            {
              title: "东盟货物贸易年度",
              links: "/data/goods/asean/annual",
            },
          ],
        },

        {
          title: "韩国海关  >",
          tilteColor: "",
          lists: [
            {
              title: "韩国货物贸易月度",
              links: "/data/goods/asia/korea/monthly",
            },
            {
              title: "韩国货物贸易年度",
              links: "/data/goods/asia/korea/annual",
            },
          ],
        },
        {
          title: "印度尼西亚海关  >",
          tilteColor: "",
          lists: [
            {
              title: "印尼货物贸易月度",
              links: "/data/goods/asia/indonesia/monthly",
            },
            {
              title: "印尼货物贸易年度",
              links: "/data/goods/asia/indonesia/annual",
            },
          ],
        },
        {
          title: "日本海关  >",
          tilteColor: "",
          lists: [
            {
              title: "日本货物贸易月度",
              links: "/data/goods/asia/japan/monthly",
            },
            {
              title: "日本货物贸易年度",
              links: "/data/goods/asia/japan/annual",
            },
          ],
        },
        {
          title: "菲律宾统计局  >",
          tilteColor: "",
          lists: [
            {
              title: "菲律宾货物贸易月度",
              links: "/data/goods/asia/philippines/monthly2024",
            },
            {
              title: "菲律宾货物贸易年度",
              links: "/data/goods/asia/philippines/annual2024",
            },
          ],
        },
        {
          title: "马来西亚统计局  >",
          tilteColor: "",
          lists: [
            {
              title: "马来西亚货物贸易月度",
              links: "/data/goods/asia/malaysia/monthly",
            },
            {
              title: "马来西亚货物贸易年度",
              links: "/data/goods/asia/malaysia/annual",
            },
          ],
        },

        {
          title: "泰国海关  >",
          tilteColor: "",
          lists: [
            {
              title: "泰国货物贸易月度",
              links: "/data/goods/asia/thailand/monthly",
            },
            {
              title: "泰国货物贸易年度",
              links: "/data/goods/asia/thailand/annual",
            },
          ],
        },
        {
          title: "秘鲁出口和旅游促进委员会  >",
          tilteColor: "",
          lists: [
            {
              title: "秘鲁货物贸易月度",
              links: "/data/goods/nmz/bilu/monthly",
            },
            {
              title: "秘鲁货物贸易年度",
              links: "/data/goods/nmz/bilu/annual",
            },
          ],
        },
        {
          title: "智利海关  >",
          tilteColor: "",
          lists: [
            {
              title: "智利货物贸易月度",
              links: "/data/goods/nmz/zhili/monthly",
            },
            {
              title: "智利货物贸易年度",
              links: "/data/goods/nmz/zhili/annual",
            },
          ],
        },
        {
          title: "新西兰统计局  >",
          tilteColor: "",
          lists: [
            {
              title: "新西兰货物贸易月度",
              links: "/data/goods/dyz/xxl/monthly",
            },
            {
              title: "新西兰货物贸易年度",
              links: "/data/goods/dyz/xxl/annual",
            },
          ],
        },
        {
          title: "加拿大统计局  >",
          tilteColor: "",
          lists: [
            {
              title: "加拿大本地出口货物贸易月度",
              links: "/data/goods/bmz/jnd/monthlyjc",
            },
            {
              title: "加拿大总出口货物贸易月度",
              links: "/data/goods/bmz/jnd/monthlyc",
            },
            {
              title: "加拿大进口货物贸易月度",
              links: "/data/goods/bmz/jnd/monthlyj",
            },
            {
              title: "",
              links: "",
            },
          ],
        },
        {
          title: "欧盟统计局  >",
          tilteColor: "#81bf22",
          lists: [
            {
              title: "欧盟货物贸易月度",
              links: "/data/goods/EU/monthly",
            },
            {
              title: "欧盟货物贸易年度",
              links: "/data/goods/EU/annual",
            },
          ],
        },
        {
          title: "中国香港政府统计处  >",
          tilteColor: "#81bf22",
          lists: [
            {
              title: "中国香港货物贸易月度",
              links: "/data/goods/asia/HK/monthly",
            },
            {
              title: "中国香港物贸易年度",
              links: "/data/goods/asia/HK/annual",
            },
          ],
        },
        {
          title: "中国澳门统计暨普查局  >",
          tilteColor: "#81bf22",
          lists: [
            {
              title: "中国澳门货物贸易月度",
              links: "/data/goods/asia/Macao/monthly",
            },
            {
              title: "中国澳门货物贸易年度",
              links: "/data/goods/asia/Macao/annual",
            },
          ],
        },
        {
          title: "南非税务局  >",
          tilteColor: "#d9001b",
          lists: [
            {
              title: "南非货物贸易月度",
              links: "/data/goods/AF/southAfrica/monthly",
            },
            {
              title: "南非货物贸易年度",
              links: "/data/goods/AF/southAfrica/annual",
            },
          ],
        },
        {
          title: "法国外贸统计局  >",
          tilteColor: "#d9001b",
          lists: [
            {
              title: "法国货物贸易月度",
              links: "/data/goods/europe/france/monthly",
            },
            {
              title: "法国货物贸易年度",
              links: "/data/goods/europe/france/annual",
            },
          ],
        },
        {
          title: "阿根廷国家统计局  >",
          tilteColor: "#d9001b",
          lists: [
            {
              title: "阿根廷货物贸易月度",
              links: "/data/goods/nmz/argentina/monthly",
            },
            {
              title: "阿根廷货物贸易年度",
              links: "/data/goods/nmz/argentina/annual",
            },
          ],
        },
        {
          title: "美国国际贸易委员会  >",
          tilteColor: "#d9001b",
          lists: [
            {
              title: "美国本地出口货物贸易月度",
              links: "/data/goods/bmz/USA/monthbdck",
            },
            {
              title: "美国总出口货物贸易月度",
              links: "/data/goods/bmz/USA/monthzck",
            },

            {
              title: "美国消费进口货物贸易月度",
              links: "/data/goods/bmz/USA/monthxfjk",
            },
            {
              title: "美国一般进口货物贸易月度",
              links: "/data/goods/bmz/USA/monthybjk",
            },
          ],
        },
        {
          title: "中国台湾省经济部国际贸易署  >",
          tilteColor: "#02a7f0",
          lists: [
            {
              title: "中国台湾省货物贸易月度",
              links: "/data/goods/asia/taiwan/monthly",
            },
            {
              title: "中国台湾省货物贸易年度",
              links: "/data/goods/asia/taiwan/annual",
            },
          ],
        },
        {
          title: "巴西发展、工业、贸易和服务部  >",
          tilteColor: "#02a7f0",
          clearRow: true,
          lists: [
            {
              title: "巴西货物贸易月度",
              links: "/data/goods/nmz/brazil/monthly",
            },
            {
              title: "巴西货物贸易年度",
              links: "/data/goods/nmz/brazil/annual",
            },{
              title: "",
              links: "",
            },{
              title: "",
              links: "",
            },{
              title: "",
              links: "",
            },{
              title: "",
              links: "",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["isLogin", "userName"]),
    title() {
      switch (this.type) {
        case "1":
          return "系统介绍";
        case "2":
          return "指标解释";
        case "3":
          return "帮助文档";
      }
    },
  },
  mounted() {
    // document.documentElement.style.fontSize =
    //   document.documentElement.clientWidth / 1920 + "px";
    // window.onresize = function () {
    //   document.documentElement.style.fontSize =
    //     document.documentElement.clientWidth / 1920 + "px";
    // };
  },
  methods: {
    login() {
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(6);
      } catch (e) {}
      window.location.href = LOGIN_URL();
    },
    logout() {
      $.ajax({
        url: "//d.drcnet.com.cn/eDRCnet.common.web/login/login.ashx?flag=logoutp", //initp 查询目前用户登录状态，logoutp 退出登录
        type: "get",
        dataType: "jsonp", //指定服务器返回的数据类型
        jsonpCallback: "showData", //指定回调函数名称
        xhrFields: { withCredentials: true },
        crossDomain: true,
        async: false,
        success: function (data) {
          // //console.log(data)
          removeToken();
          window.location.href = "/data/goods/asia/china/monthly";
        },
      });
    },
    toLinks(link) {
      //需要删除localstore
      // localStorage.removeToken("routeName");
      this.$router.push({ path: link });
    },
  },
};
</script>

<style lang="scss" scoped>
.right-menu {
  float: right;
  height: 100%;
  line-height: 50px;
  font-size: 16px;
  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    .avatar-wrapper {
      position: relative;
      line-height: 60px;
      width: 40px;
      text-align: center;
      cursor: pointer;
      .iconfont {
        font-size: 24px;
        color: #fff;
        vertical-align: sub;
      }
      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
.dropClass {
  display: flex;
  align-items: center;
  // flex-direction: column-reverse;
  .el-dropdown-link {
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    color: #fff;
    font-family: "Microsoft Yahei", "Source Sans Pro", "Helvetica Neue", Arial,
      sans-serif;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}
.dropDiv {
  width: 1388px;
  // height: 600px;
  font-size: 14px;
  position: relative;
  .legend {
    display: flex;
    margin-right: 20px;
    margin-bottom: 10px;
    justify-content: end;
    color: #494949;
    font-size: 12px;
  }
}
//重写头样式
.app-header__logo {
  display: flex;
  align-items: center;
  height: 100% !important;
  top: 0 !important;
  margin-top: 0 !important;
  width: 100% !important;
}
.app-header {
  padding-left: 20px !important;
  background-color: rgba(20, 87, 134, 0.8) !important;
}
.splitLines {
  width: 1px;
  height: 22px;
  background: #ffffff;
  opacity: 0.4;
  margin: 8px 0px 0 16px;
}
::v-deep .app-title {
  position: sticky !important;
  padding: 6px 25px 0 16px;
}
.databaseAll {
  .el-col {
    margin-bottom: 10px;
    border-bottom: 1px solid #f2f2f2;
  }

  .databaseAllTitle {
    padding-bottom: 10px;
    color: #004677;
    font-weight: 600;
    font-size: 15px;
  }
  .databaseAllList {
    display: inline-block;
    margin-bottom: 10px;
    cursor: pointer;
    color: #494949;
  }
}
</style>
<style lang="scss">
.el-popper.dropdownTopMenu {
  border: 1px solid #ebeef5 !important;
  padding: 20px !important;
  margin: 5px 0 !important;
  border-radius: 5px;
  top: 60px !important;
  left: 245px !important;
  .popper__arrow {
    left: 321px !important;
    border-width: 0px !important;
  }
  .popper__arrow:after {
    // border-width: 6px !important;
  }
}
</style>
